import type { PortalReference, PortalRefItem } from "../PortalReference";

/**
 * 参照を一本のリストへ統合する（活動履歴 → 企業ドキュメント → 案件資料の順）。
 *
 * 軸ごとに分けて並べるとペインが縦に伸び、片軸だけの連携で空セクションが残る。コンソールと同じく
 * 統合して出自バッジで由来を示す（[[2026-08-12 設計ノート アドインのAWS連携追随]]）。
 */
export function toRefItems(ref: PortalReference): PortalRefItem[] {
    return [
        ...ref.portalActivities.map((a, i) => ({
            ref: a.ref,
            origin: "活動" as const,
            label: a.title,
            key: a.ref ?? `act-${a.date}-${i}`,
        })),
        ...ref.portalDocuments.map((d, i) => ({
            ref: d.ref,
            origin: "企業" as const,
            label: d.fileName,
            key: d.ref ?? `doc-${d.fileName}-${i}`,
        })),
        ...ref.portalProjectDocs.map((d, i) => ({
            ref: d.ref,
            origin: "案件" as const,
            label: d.fileName,
            key: d.ref ?? `case-${d.fileName}-${i}`,
        })),
    ];
}
